import { BaseContainerModel } from '../../base-container.model';
import { bl_aat_claim_ocr_doc_hdr_RowClass, bl_aat_claim_ocr_doc_line_RowClass } from '../../../dbschema';

export class ClaimOcrDocContainerModel extends BaseContainerModel {
  bl_aat_claim_ocr_doc_hdr: bl_aat_claim_ocr_doc_hdr_RowClass = new bl_aat_claim_ocr_doc_hdr_RowClass();
  bl_aat_claim_ocr_doc_lines: bl_aat_claim_ocr_doc_line_RowClass[] = [];
}
